export default __webpack_public_path__ + "static/media/DSC_7712.dde13586.jpg";